module.exports = __webpack_public_path__ + "img/segway.45c00f5a.jpg";